import { render, staticRenderFns } from "./ShareDialogComp.vue?vue&type=template&id=34efe45c&scoped=true&"
import script from "./ShareDialogComp.vue?vue&type=script&lang=ts&"
export * from "./ShareDialogComp.vue?vue&type=script&lang=ts&"
import style0 from "./ShareDialogComp.vue?vue&type=style&index=0&id=34efe45c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34efe45c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VSwitch,VTextField})
